// --------------------------------------------------------------------------
// #44 – CAMPAIGN HERO
//     - handles the movement of the progress bar within the Campaign hero
// --------------------------------------------------------------------------
// Author:      Alex Baulch
// Email:       frontend@thisiszone.com
// URL:         http://thisiszone.com
// Copyright:   Copyright (c) 2015, thisiszone.com. All rights reserved.
// Version:     1
// --------------------------------------------------------------------------
'use strict';

var $ = require('jquery');
var commaSeparateNumber = require('../utilities/comma-separate-number');

/**
 * @module campaign-progress-bar
 * @param  { Object } options - object literal containing all the set up options for the module
 * @return { Object } returns an object containing the init function and any other functions that need to be globally accessed
 */
module.exports = function (options) {
    var context = options.context;
    var target = context.data('target');
    var received = context.data('received');
    var percentage = 100 * (received / target) + '%';
    var receivedHtml = context.find('.animated-received');
    var amountContainer = context.siblings('.received').find('.received-prefix-amount');
    var amountText = amountContainer.find('.amount');

    /** On the module being loaded set up the animations */
    function init() {
        // set to 0 so that the percentage is still correct if js is turned off
        receivedHtml.css('width', 0);

        /** set the width of the progress bar, animation is handled by css transitions */
        function animateProgressBar() {
            receivedHtml.css('width', percentage);
        }

        setTimeout(function () {
            // class added after this has happened so I can turn on transitions
            receivedHtml.addClass('zeroed');

            // also resetting the amount text so that the amount is correct with js turned off
            amountText.text('0');

            // animate the amount text from 0 to the amount received so far
            $({ amountReceived: 0 }).animate({ amountReceived: received }, {
                duration: 1000,
                easing: 'linear',
                step: function step() {
                    amountText.text(commaSeparateNumber(Math.ceil(this.amountReceived)));
                },
                complete: function complete() {
                    amountText.text(commaSeparateNumber(received));
                }
            });

            // make the amountContainer move with the progress bar
            amountContainer.css('left', percentage);

            // call function
            animateProgressBar();
        }, 1);
    }

    return {
        init: init
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/scripts/modules/campaign-progress-bar.js
// module id = 210
// module chunks = 0